import { useAppStore } from '@store'
import { Area, BackMaterialInfo } from '@types'
import { toVector3 } from '@utils/conversion/toVector3'
import { Euler } from 'three'
import areaImg from '../../../assets/area.png'
type Props = Partial<Omit<Area, 'type' | 'image'>> & { id: string }

export function getBaseArea(props: Props): Area {
  const store = useAppStore.getState()
  const texture1 = store.texture1
  const texture4 = store.texture4
  const increment = store.increment
  const textureToAdd = props.isRoof ? texture4 : texture1
  store.addIncrement()

  const baseArea: Record<string, unknown> = {
    sides: [] as string[],
    isClosed: false,
    type: 'areas',
    isRoof: false,
    image: areaImg,
    height: 0,
    textures: [],
    zones: {},
    universal: true,
    catalogID: '',
    idUnidades: -1,
    visible: true,
    ceilingVisible: true,
    url: '',
    description: '',
    increment,
  }

  if (textureToAdd) {
    baseArea.zones = {
      area: {
        position: toVector3(),
        scale: toVector3(),
        rotation: new Euler(),
        name: 'area',
        index: 0,
        material: { ...textureToAdd },
      },
    }
    baseArea.textures = [
      {
        id: textureToAdd?.id,
        searchID: textureToAdd?.searchID,
        zoneName: 'area',
        zoneDisplayName: 'MSG_182',
        url: textureToAdd?.url,
        name: textureToAdd?.name,
        zone: 'area',
        groupID: textureToAdd?.groupID,
      },
    ] as BackMaterialInfo[]
  }

  for (const [key, value] of Object.entries(props)) {
    if (!key) continue
    baseArea[key] = value
  }
  baseArea.description = props.isRoof ? 'MSG_273' : 'MSG_252'
  return baseArea as unknown as Area
}
